import React from 'react';
import { Box, IconButton, Icons, useTheme } from '@ublend-npm/aulaui-core';
import EducatorStudentToggle from '../../EducatorStudentToggle';
import { getSpaceWidgetColors } from './spaceWidgetColors';

type SpaceWidgetToolbarProps = {
  canScrollBack: boolean;
  canScrollForward: boolean;
  onScrollBack: () => void;
  onScrollForward: () => void;
  showNavigation?: boolean;
  showRoleToggle?: boolean;
};

const SpaceWidgetToolbar = ({
  canScrollBack,
  canScrollForward,
  onScrollBack,
  onScrollForward,
  showNavigation = true,
  showRoleToggle = true,
}: SpaceWidgetToolbarProps) => {
  const { palette } = useTheme();
  const colors = getSpaceWidgetColors(palette);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      width="100%"
    >
      <Box display="flex" alignItems="center" gap={1} minWidth={0}>
        {showRoleToggle ? (
          <>
            <EducatorStudentToggle />
            <IconButton
              aria-label="About home spaces"
              sx={{
                width: 24,
                height: 24,
                color: colors.navArrowIcon,
                p: 0,
              }}
            >
              <Icons.InfoOutlined sx={{ fontSize: 20 }} />
            </IconButton>
          </>
        ) : null}
      </Box>

      {showNavigation ? (
        <Box display="flex" alignItems="center" gap={1} flexShrink={0}>
          <IconButton
            aria-label="Scroll spaces left"
            disabled={!canScrollBack}
            onClick={onScrollBack}
            sx={{
              width: 40,
              height: 40,
              bgcolor: colors.navButtonBg,
              color: colors.navArrowIcon,
              opacity: canScrollBack ? 1 : colors.navButtonDisabledOpacity,
              '&:hover': {
                bgcolor: colors.navButtonBg,
              },
            }}
          >
            <Icons.ArrowBack fontSize="small" />
          </IconButton>
          <IconButton
            aria-label="Scroll spaces right"
            disabled={!canScrollForward}
            onClick={onScrollForward}
            sx={{
              width: 40,
              height: 40,
              bgcolor: colors.navButtonBg,
              color: colors.navArrowIcon,
              opacity: canScrollForward ? 1 : colors.navButtonDisabledOpacity,
              '&:hover': {
                bgcolor: colors.navButtonBg,
              },
            }}
          >
            <Icons.ArrowForward fontSize="small" />
          </IconButton>
        </Box>
      ) : null}
    </Box>
  );
};

export default SpaceWidgetToolbar;
